module.exports = __webpack_public_path__ + "static/media/ps.fe85681f.svg";